// third-party
import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from 'store';

// types

// ----------------------------------------------------------------------

const initialState: { filter: { centerId: string | null } } = {
    filter: {
        centerId: ''
    }
};

const staffList = createSlice({
    name: 'staffList',
    initialState,
    reducers: {
        setFilter(state, action) {
            state.filter = action.payload;
        }
    }
});

// Reducer
export default staffList.reducer;

export function setStaffListByCenter(step: { centerId: string | null }) {
    return () => {
        dispatch(staffList.actions.setFilter(step));
    };
}
